function normalizeName(s) {
  return (s || '').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ')
}

function getTimestamp(item) {
  const v = item.published_at || item.created_at
  return v ? new Date(v).getTime() : 0
}

export function sortPreachingsDesc(items) {
  return [...items].sort((a, b) => getTimestamp(b) - getTimestamp(a))
}

export function dedupePreachings(items, windowMs = 24 * 60 * 60 * 1000) {
  const sorted = sortPreachingsDesc(items)
  const seen = []
  const result = []
  for (const item of sorted) {
    const name = normalizeName(item.name)
    const ts = getTimestamp(item)
    const dup = seen.some(s => s.name === name && ts > 0 && s.ts > 0 && Math.abs(s.ts - ts) <= windowMs)
    if (dup) continue
    result.push(item)
    seen.push({ name, ts })
  }
  return result
}

export function pickLatestValid(items) {
  const valid = items.filter(p => p.published_at)
  const deduped = dedupePreachings(valid)
  return deduped[0] || null
}
